import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Language } from '../models/language.model';
import { shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  private languages$: Observable<Language[]> | undefined; 

  constructor(private http: HttpClient) {}

  getLanguages(): Observable<Language[]> {
    if (!this.languages$) {
      const url: string = `${environment.apiUrl}/languages`;
      this.languages$ = this.http.get<Language[]>(url).pipe(shareReplay(1));
    }
    return this.languages$;
  }
}